<template>
    <div>
        <point-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                           :paginationData="filterSet.page"></point-filter-link>
        <point-list-link :listLayout="listLayout" :pointData="List" :paginationData="filterSet.page"
                         :pointType="pointType"
                         v-loading="!finishGetList"></point-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page" :listLength="List.length"
                         :finishGetList="finishGetList" v-if="filterSet.page.total"></pagination-link>
    </div>
</template>

<script>
import PointFilterLink from "@/components/point/PointFilterLink";
import PointListLink from "@/components/point/PointListLink";
import PaginationLink from "@/components/point/PaginationLink";
import pointUtil from "@/components/point/pointUtil";
import alertMixins from "@/mixins/alertMixins";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import {pointStatus} from "@/service/pointService";

const {filterConfig} = pointUtil;

export default {
    name: "PointListComponent",
    mixins: [pointUtil, alertMixins, filterMixins, listMixins],
    components: {
        PointFilterLink,
        PointListLink,
        PaginationLink
    },
    inject: ['changeLoading'],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setSort: this.setSort,
            setPointListData: this.setData,
            pointListDelete: this.runDeleteConfirm,
            excelDown: this.excelDown,
        }
    },
    props: {
        pointType: '',
        memberKey: {default: 0},
    },
    data() {
        return {
            listLayout: '',
            filterLayout: '',
            emptyLayout: '',
            paginationLayout: '',
            getFunc: '',
            listApiParamSet: {},

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            keyName: '',
            DeleteClass: null,
            selectArr: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig);
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true);
        EventBus.$on('getPointList', this.getList)
        EventBus.$on('cancelCharge', this.cancelCharge)
        EventBus.$on('approveWithdraw', this.approveWithdraw)
        EventBus.$on('denyWithdraw', this.denyWithdraw)
    },
    beforeDestroy() {
        EventBus.$off('getPointList')
        EventBus.$off('cancelCharge')
        EventBus.$off('approveWithdraw')
        EventBus.$off('denyWithdraw')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let config = this.returnPointConfig(this.pointType);
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.emptyLayout = config.emptyLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            this.deleteFunc = config.deleteFunc
            this.deleteApiParamsSet = config.deleteApiParamsSet
            this.deleteSuccessType = config.deleteSuccessType
            this.deleteFailTypes = config.deleteFailTypes
            this.deleteKeyName = config.deleteKeyName

            if (config.pageRow && config.pageRow != this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            let params = util.isEmpty(this.listApiParamSet) ? {} : JSON.parse(JSON.stringify(this.listApiParamSet));
            if (!util.isEmpty(this.memberKey) && this.memberKey !== 0) {
                params.no = this.memberKey;
            }
            let listOptions = {
                url: this.$api.$point[this.getFunc],
                defaultParams: params,
            }
            this.sortOptions = config.sortOptions
            this.setSortOptions(this.sortOptions)
            this.initList('api', listOptions);
        },
        setData(key, value) {
            this[key] = value
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteParams = JSON.parse(JSON.stringify(this.deleteApiParamsSet))
                deleteParams.i_idx = this.itemKey
                let deleteOptions = {
                    func: this.$api.$point[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.deleteKeyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
            }
        },
        runDeleteConfirm(key, idx) {
            this.createConfirm({
                content: '정말 삭제하시겠습니까?',
                confirm: () => {
                    this.runDelete(key, idx);
                }
            })
        },
        runDelete(key, idx) {
            let params = {
                ibp_idx: key,
                i_idx: idx
            }
            try {
                this.$api.$point[this.deleteFunc](params).then(res => res.Data.Result).then(res => {
                    let result = res.List.Data.Status
                    if (!result) {
                        this.errorAlert('삭제에 실패했습니다.');
                        return false;
                    } else {
                        this.deleteAfterFunc();

                    }
                })
            } catch (e) {
                this.changeLoading(false);
                this.isRunning = false;
                console.log(e);
            }
        },
        deleteAfterFunc() {
            this.createAlert({
                content: '삭제되었습니다.',
                hide: () => {
                    this.getList()
                }
            })
        },
        cancelCharge(idx) {
            let params = {
                p_idx: idx
            }
            this.$api.$point.cancelCharge(params).then(res => res.Data.Result).then(res => {
                let result = this.returnCancelCharge(res.Info.type)
                if (result !== true) {
                    this.errorAlert(result)

                } else {
                    this.createAlert({content: '취소되었습니다.'})
                    this.getList()
                }
            })
        },
        approveWithdraw() {
            if (this.selectArr.length === 0) {
                this.errorAlert('목록을 선택해주세요.');
                return false;
            }
            this.createConfirm({
                content: '출금 완료 처리하시겠습니까?',
                confirm: () => {
                    let params = {
                        p_idx: this.selectArr
                    }
                    this.$api.$point.approveWithdraw(params).then(res => res.Data.Result).then(res => {
                        if (res.Info.type === 1) {
                            this.afterWithdraw()
                        } else {
                            this.errorAlert('출금완료 처리에 실패했습니다.')
                        }
                    })
                }
            })

        },
        denyWithdraw() {
            if (this.selectArr.length === 0) {
                this.errorAlert('목록을 선택해주세요.');
                return false;
            }
            this.createConfirm({
                content: '출금 취소 처리하시겠습니까?',
                confirm: () => {

                    let params = {
                        p_idx: this.selectArr
                    }
                    this.$api.$point.denyWithdraw(params).then(res => res.Data.Result).then(res => {
                        if (res.Info.type === 1) {
                            this.afterWithdraw()
                        } else {
                            this.errorAlert('출금취소 처리에 실패했습니다.')
                        }
                    })
                }
            })
        },
        afterWithdraw() {
            this.createAlert({
                content: '처리 완료되었습니다.',
                hide: () => {
                    this.selectArr = []
                    this.getList()
                }
            })
        },
        returnCancelCharge(type) {
            switch (type) {
                case 1: {
                    return true
                }
                case -485 : {
                    return '이미 취소된 주문입니다.'
                }
                case -901 : {
                    return '차감 포인트가 부족합니다.'
                }
                default : {
                    return '충전 취소 실패'
                }
            }
        },
        excelDown() {
            if (this.List.length < 1) {
                return
            }
            this.changeLoading(true);
            import('@/vendor/Export2Excel').then(excel => {
                const tHeader = ['아이디', '닉네임', '결제번호', '상태', '내용', '사용밍글', '현재밍글', '일자'];
                const filterVal = ['mb_id', 'mb_nick', 'p_uuid', 'pd_code', 'p_reason', 'p_point', 'p_point_history', 'created_at'];

                const data = this.formatJson(filterVal, this.List)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: `밍글 내역`
                })
                this.changeLoading(false);
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => {
                if (j === 'pd_code') {
                    return this.returnPointType(v.pd_code)
                }
                if (j === 'p_point') {
                    return `${this.returnPlus(v.p_point)}M ( ₩${this.returnWon(v.p_point)})`
                }
                if (j === 'p_point_history') {
                    return `${this.returnPoint(v.p_point_history, v.p_point)}M ( ₩${this.returnNowWon(v.p_point_history, v.p_point)})`
                }
                return this.$_.result(v, j)
            }))
        },
        returnPoint(pointHistory, point) {
            return this.returnCommas(pointHistory + point);
        },
        returnNowWon(pointHistory, point) {
            let nowPoint = pointHistory + point;
            nowPoint = nowPoint + '0';
            return this.returnCommas(nowPoint);
        },
        returnPointType(status) {
            let index = pointStatus.findIndex(ds => ds.value === status);
            if (index > -1) {
                return pointStatus[index].name;
            }
            return '-';
        },
        returnPlus(point) {
            if (point > 0) {
                point = "+" + point;
                return this.returnCommas(point);
            } else {
                return this.returnCommas(point);
            }
        },
        returnWon(point) {
            point = String(point + '0')
            if (point.charAt(0) == '-') {
                point = point.replace('-', '-₩')
            } else {
                point = "+₩" + point;
            }
            return this.returnCommas(point);
        },
        returnCommas(x = 0) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
